module.exports = __webpack_public_path__ + "img/logo_x3.dcaa64ee.webp";